import React from 'react'
import MyProjectCard from './MyProjectCard'
import Myprojectarr from "../Projects"
import Comingsoon from "../Assets/C3.png"
const ProjectsCards = ({category,setcategory}) => {
    // console.log(Myprojectarr);
    
    function filteredprojects(){
      if(category==="All"){
        return Myprojectarr;
      }
      else{
       return  Myprojectarr.filter((ele)=>{return( ele.category===category) });
      }
    }
    
  return (
    <div className='mb-10 lg:w-full lg:ml-0 flex flex-wrap gap-x-6 gap-y-10 items-center justify-center md:flex-col  ml-56'>
           
     {filteredprojects().length===0?
     <div>
      <img src={Comingsoon} alt="" />
     </div>
     :
      filteredprojects().map((ele)=>{
        return(
          <MyProjectCard ele={ele} />
          )
      })
     }
    </div>
  )

}

export default ProjectsCards
